import { CollapsableComponent } from 'src/components/collapsible-section';
import { ProductListComponent } from '../products-list';
import { useGetPopularProducts } from 'src/hooks/fetch/use-get-popular-products.hook';
import { Box, CircularProgress } from '@mui/material';
import { useState } from 'react';

const rowsPerPage = 16;

export const MostViewedProducts = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { data, isLoading } = useGetPopularProducts(
    {
      pageSize: rowsPerPage
    },
    { enabled: isOpen }
  );

  const handleToggle = (open: boolean) => {
    setIsOpen(open);
  };

  return (
    <CollapsableComponent label="Most viewed products" defaultOpen={false} onToggle={handleToggle}>
      <Box id="index__components-home-most-viewed-products__box__l25" sx={{ width: '100%', position: 'relative', minHeight: 100, pt: '18px' }}>
        {isLoading &&
        <Box id="index__components-home-most-viewed-products__box__l27" sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        }
        {!isLoading && data && <ProductListComponent products={data.items} />}
      </Box>
    </CollapsableComponent>);

};